import React, {useEffect, useState} from 'react';
import {TwitterPicker} from "react-color";

// Tableau centralisé des couleurs par défaut
const DEFAULT_COLORS = [
    "#00B0FF", "#0B64CB", "#F8D541", "#FF9436", "#53CDBE",
    "#8B6DE2", "#F46AD5", "#66BE63", "#F82121", "#D7F3FF",
    "#FFFBF3", "#CEC6F6", "#A4E6A2"
];

const PaletteCouleurs = ({defaultColor, onColorChange, width = "38", height = "39", showWarningIfNoColor = false}) => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState(defaultColor ?? '#00B0FF')
    const [recentColors, setRecentColors] = useState(['', '', '']);

    useEffect(() => {
        const storedColors = localStorage.getItem('MVPRecentColors');
        if (storedColors) {
            setRecentColors(JSON.parse(storedColors));
        }
    }, []);
    useEffect(() => {
        setColor(defaultColor ?? '#00B0FF');
    }, [defaultColor]);

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    const handleChange = (newColor) => {
        const colorHex = newColor.hex;

        // Vérifier si la couleur est déjà dans la liste et exclure "transparent"
        if (colorHex === "transparent") return;

        // Vérifier si la couleur est déjà dans DEFAULT_COLORS
        if (DEFAULT_COLORS.includes(colorHex)) return;

        // Filtrer les doublons et conserver 3 couleurs max
        const filteredColors = recentColors.filter(c => c !== colorHex); // Supprime les doublons
        const updatedRecentColors = [...filteredColors, colorHex].slice(-3); // Garde 3 couleurs max

        setRecentColors(updatedRecentColors);
        localStorage.setItem('MVPRecentColors', JSON.stringify(recentColors));

        setColor(colorHex);
        onColorChange(colorHex);
    };

    const styles = {
        swatch: {cursor: 'pointer'},
        popover: {position: 'absolute', zIndex: '2', left: '1.3em'},
        cover: {position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px'},
    };

    const showSvgTransparent = showWarningIfNoColor && (!defaultColor || defaultColor === 'transparent');

    return (
        <div style={{position: "relative"}}>

            <svg width={width} height={height} viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg"
                 onClick={handleClick} style={styles.swatch}>
                {/* Définition du motif pour symboliser la transparence */}
                <defs>
                    <pattern id="transparentPattern" width="6" height="6" patternUnits="userSpaceOnUse">
                        <rect width="3" height="3" fill="#ccc"/>
                        <rect x="3" y="3" width="3" height="3" fill="#ccc"/>
                    </pattern>
                </defs>

                {/* Si showSvgTransparent est activé, applique le motif en damier */}
                <rect x="5.35547" y="6" width="27" height="27" rx="13.5"
                      fill={showSvgTransparent ? "url(#transparentPattern)" : color}
                      stroke={showSvgTransparent ? "#aaa" : color}/>

                <rect x="1" y="1.5" width="36" height="36" rx="18"
                      stroke={showSvgTransparent ? "#aaa" : color} strokeWidth="2"/>
            </svg>
            {
                displayColorPicker && (
                    <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose}/>
                        <TwitterPicker
                            color={color}
                            colors={[
                                ...DEFAULT_COLORS,
                                showWarningIfNoColor ? "transparent" : null,
                                ...recentColors.filter(c => showWarningIfNoColor || c !== "transparent")
                            ].filter(Boolean)}
                            onChange={handleChange}
                        />
                    </div>
                )}
        </div>
    );
};

export default PaletteCouleurs;